import { PageLoader } from '@shared/ui/page-loader';
import { LoadErrorBoundary } from '@shared/ui/load-error-boundary';

export const RouteLoadError = () => (
  <LoadErrorBoundary page error="Не удалось загрузить страницу." onRetry={() => window.location.reload()}>
    <PageLoader />
  </LoadErrorBoundary>
);
